import Vue from 'vue'
import {gaSendEvent, gaSendPageview, installGoogleAnalytics} from "@/components/Analytics";
import HomeAds4 from "@/views/HomeAds4.vue";
import {installGanalytics, trackEvent} from "@/components/Tracker";

installGoogleAnalytics();
Vue.config.productionTip = false;

new Vue({
  render: h => h(HomeAds4)
}).$mount('#home2-mount');

installGanalytics();
gaSendPageview("/free-gantt-chart-software");
